/**
 * @param {Array<{ category?: string }>} children
 * @returns {Array<{ title: string, links: Array }>}
 */
export function groupChildrenByCategory(children) {
  if (!Array.isArray(children) || children.length === 0) {
    return [];
  }

  const groups = [];
  const indexByCategory = new Map();

  children.forEach(child => {
    const title = (child.category || "").trim();
    const key = title || "__uncategorized__";

    if (!indexByCategory.has(key)) {
      indexByCategory.set(key, groups.length);
      groups.push({ title, links: [] });
    }

    groups[indexByCategory.get(key)].links.push(child);
  });

  return groups;
}

/**
 * Grouped when any child has a category, otherwise a flat list of links.
 * `megaMenu.layout` ("grouped" | "flat") is an optional explicit override.
 *
 * @param {object} navItem
 * @returns {'grouped' | 'flat'}
 */
export function inferMegaLayout(navItem) {
  const override = navItem.megaMenu && navItem.megaMenu.layout;
  if (override === "grouped" || override === "flat") {
    return override;
  }
  const children = Array.isArray(navItem.children) ? navItem.children : [];
  return children.some(child => (child.category || "").trim())
    ? "grouped"
    : "flat";
}

/**
 * @param {object} navItem
 * @returns {{ title: string, description: string, ctaText: string, ctaURL: string, layout: 'grouped' | 'flat' }}
 */
export function getMegaMenuMeta(navItem) {
  const mega = navItem.megaMenu || {};
  return {
    title: mega.title || navItem.pageName || "",
    description: mega.description || "",
    ctaText: mega.ctaText || "Learn more",
    ctaURL: mega.ctaURL || navItem.pageURL || "#",
    layout: inferMegaLayout(navItem)
  };
}

/**
 * @param {object} navItem
 * @returns {boolean}
 */
export function navItemHasMegaMenu(navItem) {
  return Array.isArray(navItem.children) && navItem.children.length > 0;
}
